import React from 'react';
import type {ItemFormErrors, ItemFormValues, UseItemForm} from '../../hooks/useItemForm';
import type {BrandOption, ItemFormRefs} from './types';
import BrandSearchSelect from '../BrandSearchSelect';
import {ChipGroup, FieldRow, SelectField, TextField} from './ItemFormControls';

export interface ItemFormTraitsProps {
    values: ItemFormValues;
    errors: ItemFormErrors;
    refs: ItemFormRefs;
    setField: UseItemForm['setField'];
    toggle: UseItemForm['toggle'];
    onBrandsUpdate: (brands: BrandOption[]) => void;
    ownerId?: string;
}

/** Свойства самой вещи: размер, состояние, бренд, цвета, цена, материалы, крой. */
const ItemFormTraits: React.FC<ItemFormTraitsProps> = ({
    values, errors, refs, setField, toggle, onBrandsUpdate, ownerId
}) => (
    <>
        <FieldRow>
            <SelectField
                id="item-size"
                label="Размер"
                value={values.sizeId}
                options={refs.sizes}
                onChange={v => setField('sizeId', v)}
            />
            <SelectField
                id="item-condition"
                label="Состояние"
                value={values.conditionId}
                options={refs.conditions}
                onChange={v => setField('conditionId', v)}
            />
        </FieldRow>
        <FieldRow>
            <div>
                <label
                    htmlFor="item-brand"
                    className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
                >
                    Бренд
                </label>
                <BrandSearchSelect
                    inputId="item-brand"
                    brands={refs.brands}
                    value={values.brandId}
                    onChange={v => setField('brandId', v)}
                    onBrandsUpdate={onBrandsUpdate}
                    placeholder="Найти или создать бренд"
                    ownerId={ownerId}
                />
            </div>
            <TextField
                id="item-price"
                label="Цена (₽)"
                type="number"
                min="0"
                step="0.01"
                blockEnter
                placeholder="0"
                value={values.priceRub}
                error={errors.priceRub}
                onChange={v => setField('priceRub', v)}
            />
        </FieldRow>
        <ChipGroup
            legend="Цвета"
            testId="item-chips-colors"
            options={refs.colors}
            selected={values.colorIds}
            onToggle={id => toggle('colorIds', id)}
        />
        <ChipGroup
            legend="Материалы"
            testId="item-chips-materials"
            options={refs.materials}
            selected={values.materialIds}
            onToggle={id => toggle('materialIds', id)}
        />
        <FieldRow>
            <SelectField
                id="item-print-type"
                label="Рисунок / принт"
                value={values.printTypeId}
                options={refs.printTypes}
                onChange={v => setField('printTypeId', v)}
            />
            <SelectField
                id="item-fit"
                label="Крой"
                value={values.fitId}
                options={refs.fits}
                onChange={v => setField('fitId', v)}
            />
        </FieldRow>
    </>
);

export default ItemFormTraits;
